import React from 'react'
import Sidebar from './sidebar'
import "../styles/layout/wrapper.scss"

const Wrapper = ({ children }) => {
    return (
        <div className='wrapper-new'>
            <Sidebar children={children} />
        </div>
    )
}

export default Wrapper
